export default "__VITE_ASSET__88e4973b__"